// extracted by mini-css-extract-plugin
export default {"ribbonContainer":"BetaRibbon_ribbonContainer__ZtddF","ribbonContainerInner":"BetaRibbon_ribbonContainerInner__P95QG","ribbon":"BetaRibbon_ribbon__oZhxh"};